import PageLayer from "@/Layouts/views/PageLayer";
import QueueMappingLayer from "../../components/QueueMapping/QueueMappingLayer";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/settings/QueueMappingIcon.svg";

export default function QueueMapping() {
	return (
		<PageLayer
			title="Queue Mapping"
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon viewBox="-2 -2 24 24" className="text-[var(--strong-purple-color)] !text-[27px]" component={Icon} />
				</Stack>
			}
		>
			<QueueMappingLayer />
		</PageLayer>
	);
}
